import Vue from 'vue';

Vue.component('vuetable-drawer-session', () =>
    import(/* webpackChunkName: 'drawer-session-index' */ './vuetable-drawer-session.vue'),
);



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/report/drawersession/index.js